import type { alertes as Fr } from '../fr/alertes';

/** « alertes » in English — typed on the French: a missing sentence does not compile. */
export const alertes: typeof Fr = {
};
